export const MAPS_API_KEY = 'AIzaSyCB9hwCSY_pAyIihqnO4BNbeF9IbQKCYIc';

export enum MapRegion {
  World = 'World',
  US = 'United States',
  NORTH_AMERICA = 'North America',
  CENTRAL_AMERICA = 'Central America',
  SOUTH_AMERICA = 'South America',
  AFRICA = 'Africa',
  NORTH_AFRICA = 'Northern Africa',
  CENTRAL_AFRICA = 'Central Africa',
  SOUTH_AFRICA = 'Southern Africa',
  OCEANIA = 'Oceania',
  EAST_ASIA = 'Eastern Asia',
  SOUTH_ASIA = 'Southern Asia',
  ASIA_PACIFIC = 'Asia/Pacific Region',
  CENTRAL_ASIA = 'Central Asia',
  MIDDLE_EAST = 'Middle East',
  NORTH_ASIA = 'Northern Asia',
  NORTH_EUROPE = 'Northern Europe',
  WEST_EUROPE = 'Western Europe',
  SOUTH_EUROPE = 'Southern Europe',
}

export const MapRegionIds: Record<MapRegion, string> = {
  [MapRegion.World]: 'world',
  [MapRegion.US]: 'US',
  [MapRegion.NORTH_AMERICA]: '021',
  [MapRegion.CENTRAL_AMERICA]: '013',
  [MapRegion.SOUTH_AMERICA]: '005',
  [MapRegion.AFRICA]: '002',
  [MapRegion.NORTH_AFRICA]: '015',
  [MapRegion.CENTRAL_AFRICA]: '017',
  [MapRegion.SOUTH_AFRICA]: '018',
  [MapRegion.OCEANIA]: '009',
  [MapRegion.EAST_ASIA]: '030',
  [MapRegion.SOUTH_ASIA]: '035',
  [MapRegion.ASIA_PACIFIC]: '142',
  [MapRegion.CENTRAL_ASIA]: '143',
  [MapRegion.MIDDLE_EAST]: '145',
  [MapRegion.NORTH_ASIA]: '151',
  [MapRegion.NORTH_EUROPE]: '154',
  [MapRegion.WEST_EUROPE]: '155',
  [MapRegion.SOUTH_EUROPE]: '039',
};

export const REGIONS_OPTIONS = Object.values(MapRegion).map((region) => ({
  id: MapRegionIds[region],
  value: MapRegionIds[region],
  label: region,
}));

export const STARTING_REGION = [MapRegionIds[MapRegion.NORTH_AMERICA]];
